document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
      const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const button = form.querySelector('[type="submit"]');
    if (!select || !button) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      button.disabled = option.disabled;
      button.textContent = option.disabled ? 'Elfogyott' : 'Kosárba teszem';
    });
  });
});
